<template>
  <router-view/>
</template>

<script>
import { defineComponent, provide, ref } from 'vue';  
import '@fortawesome/fontawesome-free/css/all.css';      // 引入图标样式 

export default defineComponent({  
  setup() {  
    // 创建全局用户信息
    const userfinfo = ref({
      token: '',
      userid: '',
      username: '',
      lastlogintime: ''
    });
    
    provide('userfinfo', userfinfo);
    return { userfinfo };  
  }  
});  
</script> 

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
